import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { NeuButton } from "../../components/neu/Neu";
import { Field } from "../../components/neu/Field";

// صندوق تأكيد الاستقالة (خطوة ثانية إلزامية قبل الإرسال).
export const ResignationConfirm = ({ busy, onConfirm, onCancel }) => {
  const { t } = useTranslation();
  return (
    <div className="mt-5 rounded-2xl bg-destructive/10 p-4" data-testid="resignation-confirm-box">
      <p className="text-sm font-semibold text-destructive">{t("resignation.confirm")}</p>
      <div className="mt-3 flex gap-2">
        <NeuButton variant="danger" data-testid="resignation-confirm" disabled={busy} onClick={onConfirm}>
          {t("resignation.confirmYes")}
        </NeuButton>
        <NeuButton data-testid="resignation-cancel" onClick={onCancel}>
          {t("app.cancel")}
        </NeuButton>
      </div>
    </div>
  );
};

export const ResignationFields = ({ policy, form, setForm }) => {
  const { t } = useTranslation();
  const pickDay = (v) => {
    if (v && v < policy.last_working_day) {
      toast.error(t("resignation.tooEarly", { date: policy.last_working_day }));
      v = policy.last_working_day;
    }
    setForm({ ...form, requested_last_day: v });
  };
  return (
    <div className="mt-4 grid gap-4 sm:grid-cols-2">
      <div className="rounded-2xl p-4 shadow-neu-in" data-testid="resignation-policy">
        <p className="text-xs text-muted-foreground">{t("resignation.noticeDays", { count: policy.notice_days })}</p>
        <p className="mt-1 text-xs text-muted-foreground">{t("resignation.computedLastDay")}</p>
        <p className="mt-1 font-mono text-2xl font-black text-primary" data-testid="resignation-last-day">
          {policy.last_working_day}
        </p>
      </div>
      <div className="grid gap-4">
        <Field
          label={t("resignation.requestedLastDay")}
          testId="resignation-requested-day"
          type="date"
          min={policy.last_working_day}
          value={form.requested_last_day}
          onChange={pickDay}
        />
        <Field
          label={t("resignation.reason")}
          testId="resignation-reason"
          value={form.reason}
          onChange={(v) => setForm({ ...form, reason: v })}
        />
      </div>
    </div>
  );
};
